import api from './axiosConfig';

const accountingClientsAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/accounting-clients', { params: { limit: 'all', ...params } });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch accounting clients';
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/accounting-clients/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch accounting client';
    }
  },

  create: async (clientData) => {
    try {
      const response = await api.post('/accounting-clients', clientData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to create accounting client';
    }
  },

  update: async (id, clientData) => {
    try {
      const response = await api.put(`/accounting-clients/${id}`, clientData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to update accounting client';
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/accounting-clients/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to delete accounting client';
    }
  },

  // Client-specific methods
  archive: async (id) => {
    try {
      const response = await api.post(`/accounting-clients/${id}/archive`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to archive accounting client';
    }
  },

  search: async (searchTerm) => {
    try {
      const response = await api.get('/accounting-clients', {
        params: { search: searchTerm }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to search accounting clients';
    }
  },

  getByType: async (clientType) => {
    try {
      const response = await api.get('/accounting-clients', {
        params: { clientType }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || `Failed to fetch ${clientType} clients`;
    }
  },

  getActive: async () => {
    try {
      const response = await api.get('/accounting-clients', {
        params: { isActive: true }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || 'Failed to fetch active clients';
    }
  },

  seedTaxAccounts: (clientId, payload) =>
  api.post(`/accounting-clients/${clientId}/seed-tax-accounts`, payload),

  
};

export default accountingClientsAPI;